const cookies = {
    getCookie: (cname) => {
        if (typeof(document) === "undefined") return "";
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },
      setCookie: (cname, cvalue, expires) => {
        if (typeof(document) === "undefined") return;
        const d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        expires = expires || "expires=" + d.toUTCString();
        document.cookie = `${cname}=${cvalue};${expires};path=/;SameSite=Strict;${window.location.protocol === 'https' ? 'secure;': ''}`;
      },
      deleteCookie: (cname) => {
        cookies.setCookie(cname, "", "expires=Thu, 01 Jan 1970 00:00:01 GMT");
      }
}

export default cookies;